import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { Product } from '../models/data.model';
import { StartupService } from './startup.service';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class ScrollingService {
  public ScrollLeft: Subject<Object>;

  private messageSource = new BehaviorSubject<Number>(0);
  currentMessage = this.messageSource.asObservable();

  constructor() {
  }

  changeMessage(message: Number) {
    this.messageSource.next(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/scrolling.service.ts